import { Message } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

import { HttpClient, parseRequestOptionsToUrlParams, QueryParameters } from '../utils';
import { RequestOptions } from './requestOptions';

export type MessagesPage = {
  items: Message[];
};

export const getMessages = async (
  roomId: string,
  channelId: string,
  options: RequestOptions<Message>,
  anchorId?: string,
  direction?: 'after' | 'before',
  include?: boolean,
): Promise<MessagesPage> => {
  const url = API_FACTORY.v4(`rooms/${encodeURIComponent(roomId)}/channels/${encodeURIComponent(channelId)}/messages`);
  const response = await HttpClient.get<Message[]>(url, {
    ...parseMessagesQueryOptions(options, anchorId, direction, include),
  });

  return {
    items: response.map(message => ({
      ...message,
      channelId,
    })),
  };
};

export const parseMessagesQueryOptions = (
  options: RequestOptions<Message>,
  anchorId?: string,
  direction?: 'after' | 'before',
  include?: boolean,
): QueryParameters => {
  const params = parseRequestOptionsToUrlParams(options);
  return {
    ...params,
    ...(direction ? { direction } : {}),
    ...(anchorId ? { pagination: { ...params.pagination, anchorId, ...(include !== undefined ? { include } : {}) } } : {}),
  };
};
